exports.handlers = {
  mdxjsEsm: handleMdxjsEsm
};

function handleMdxjsEsm(node) {
  return node.value || '';
}